import React, { lazy } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall, formattedPrice,
  getBranches,
  getEmployes,
  getStatus,
  getTypes,
} from "../../helpers/MainHelper";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/scss/image-gallery.scss";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
import logo from "../../assets/images/no-image.png";
import withPermissions from "../../components/WithPermissions";
import Select from "react-select";
import { openCustomerDetailModel, closeCustomerDetailModel, openVehicleDetailModel, closeVehicleDetailModel } from "../../actions";
class ServiceMotoDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      service: [],
      employes: [],
      branches: [],
      types: [],
      status: [],
      images: [],
      brands: [],
      models: [],
      cities: [],
      districts: [],
      selectedBrand: '',
      selectedModel: '',
      formData: {
        operationData: {
          id: '',
          assigned_employee_id: '',
          operation_type_id: '',
          description: '',
          price: '',
          vehicle_id: '',
          branch_id: '',
          review_count: '',
          brand: '',
          model: '',
          customer_name: '',
          customer_surname: '',
          plate: ''
        },
        operationStatus: {
          statu_id: '',
          customer_id: '',
          status_details: ''
        },
        vehicleData: {
          brand: '',
          branch_id: '',
          model: '',
          plate: '',
          year: '',
          km: '',
          chassis_no: '',
          engine_no: '',
          package_name: '',
          engine_size: '',
          key_no: '',
          details: '',
          vehicleImages: [],
          maintenance_date: '',
          next_maintenance_date: '',
          inspection_date: '',
          next_inspection_date: '',
          gear_type: '',
          cooling: '',
          body_type: '',
          fuel_type: '',
          fuel_tank: '',
          number_of_gears: '',
          stroke: '',
          cylinder: '',
          hp: '',
        },
        customerData: {
          id: '',
          name: '',
          surname: '',
          phone: '',
          address: '',
          email: '',
          tax_district: '',
          tax_no: '',
          title: '',
          city_id: '',
          district_id: '',
        },
      },
      created_at: '',
      processes: [{ process: "", price: "", cost: "", kdv: "", discount: "", unit: "C62", quantity: 1 }],
      isLoad: true,
      statusLoading: false,
      processLoading: false,
      operationLoading: false,
      customerLoading: false,
      vehicleLoading: false,
      isStatusComplete: false,
    };
  }

  async componentDidMount() {
    try {
      this.getBrands();
      this.getCities();
      await this.getServiceInfo();
      const branches = await getBranches();
      const employes = await getEmployes();
      const types = await getTypes();
      const status = await getStatus();
      this.setState({ branches, employes, types, status }, () => {
        this.setState({ isLoad: false });
      });
    } catch (error) {
      this.setState({ isLoad: false });
      console.error("Error fetching initial data:", error);
    }
  }
  getCities = async () => {

    const citiesFromStorage = localStorage.getItem('cities');

    if (citiesFromStorage) {
      this.setState({ cities: JSON.parse(citiesFromStorage) });
    } else {
      const response = await apiCall('get-cities', 'get', null);
      this.setState({ cities: response });

      localStorage.setItem('cities', JSON.stringify(response));
    }
  }

  handleCityChange = async (event) => {
    const city_id = event.target.value;

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        customerData: {
          ...prevState.formData.customerData,
          city_id: city_id,
          district_id: ""
        }
      },
      districts: []
    }));

    if (city_id) {
      const response = await apiCall(`get-dist/${city_id}`, 'get', null);
      this.setState({ districts: response });
    }
  }
  getBrands = async () => {
    const response = await apiCall('business/vehicle/get-moto-brands', 'get', null);
    const brandOptions = response.map(brand => ({
      value: brand.id,
      label: brand.name
    }));
    this.setState({ brands: brandOptions });
  }
  getModels = async (brandID) => {
    const response = await apiCall('business/vehicle/get-moto-models/' + brandID, 'get', null);
    const modelOptions = response.map(brand => ({
      value: brand.id,
      label: brand.name
    }));
    this.setState({ models: modelOptions });
  }

  handleBrandChange = async (selectedOption) => {
    const brand_id = selectedOption.value;
    const option = {
      value: selectedOption.value,
      label: selectedOption.label
    }
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        vehicleData: {
          ...prevState.formData.vehicleData,
          brand: brand_id,
          model: ""
        }
      },
      selectedBrand: option,
      models: []
    }));

    if (brand_id) {
      try {
        const response = await apiCall(`business/vehicle/get-models/${brand_id}`, 'get', null);

        const modelOptions = response.map(model => ({
          value: model.id,
          label: model.name
        }));
        this.setState({ models: modelOptions });
      } catch (error) {
        console.error("Modelleri alırken hata oluştu:", error);
      }
    }
  }
  handleModelChange = async (selectedOption) => {
    const model_id = selectedOption.value;
    const option = {
      value: selectedOption.value,
      label: selectedOption.label
    }
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        vehicleData: {
          ...prevState.formData.vehicleData,
          model: model_id
        }
      },
      selectedModel: option,
    }));
  }
  getServiceInfo = async () => {
    const id = this.props.match.params.id;
    try {
      const response = await apiCall(`business/operation/moto/info/${id}`, 'get', null);
      const { formData } = this.state;

      const newFormData = {
        ...formData,
        operationData: {
          ...formData.operationData,
          id: response.id,
          version: response.version,
          assigned_employee_id: response.assigned_employee_id || "",
          operation_type_id: response.operation_type_id || "",
          review_count: response.review_count || "",
          description: response.description || '',
          price: response.price || "",
          vehicle_id: response.vehicle?.id || '',
          plate: response.vehicle?.plate || '',
          branch_id: response.vehicle?.branch?.id || '',
          brand: response.vehicle?.moto_brand?.name || '',
          model: response.vehicle?.moto_model?.name || '',
          customer_name: response.vehicle?.customer?.name || '',
          customer_surname: response.vehicle?.customer?.surname || '',
        },
        operationStatus: {
          statu_id: response.statu_id || '',
          status_details: Object.prototype.hasOwnProperty.call(response, 'status_details')
            ? (response.status_details ?? '')
            : (response.status?.details ?? ''),
          customer_id: response.vehicle?.customer?.id || '',
        }
      };

      this.setState({
        formData: newFormData,
        created_at: mainHelper.dateFormat(new Date(response.created_at)),
        processes: JSON.parse(response.process) || [{ process: "", price: "", cost: "", kdv: "", discount: "", unit: "C62", quantity: 1 }],
      });
      let vehicleImages = [];
      const baseURL = 'https://apizone.servicezone.com.tr/images/vehicle/';

      if (response.vehicle.images) {
        vehicleImages = JSON.parse(response.vehicle.images).map(image => ({
          original: `${baseURL}${image}`,
          thumbnail: `${baseURL}${image}`,
          name: `${image}`,
        }));
      }
      if (vehicleImages.length === 0) {
        vehicleImages.push({
          original: logo,
          thumbnail: logo,
          name: "logo-icon.png",
        });
      }
      this.setState({ images: vehicleImages });
    } catch (error) {
      this.setState({ isLoad: false });
      console.error("Error fetching service info:", error);
    }
  }
  handleAddProcess = () => {
    this.setState((prevState) => ({
      processes: [...prevState.processes, { process: "", price: "", cost: "", kdv: "", discount: "", unit: "C62", quantity: 1 }],
    }));
  };

  handleRemoveProcess = (index) => {
    this.setState((prevState) => ({
      processes: prevState.processes.filter((_, i) => i !== index),
    }));
  };
  calculateTotals = () => {
    const { processes } = this.state;
    let totalCost = 0;
    let totalPrice = 0;
    let totalWithKdv = 0;
    let totalKdv = 0;
    let totalDiscount = 0;
    let discount = 0;

    processes.forEach((process) => {
      const cost = parseFloat(process.cost) || 0;
      const quantity = parseFloat(process.quantity) || 0;
      const price = parseFloat(process.price) || 0;
      const kdvRate = parseFloat(process.kdv) || 0;
      const discountRate = parseFloat(process.discount) || 0;
      discount = (price * quantity * discountRate) / 100;
      totalCost += cost * quantity;
      totalPrice += price * quantity;
      totalDiscount += discount;

      const discountedPrice = (price * quantity) - discount;
      const kdvAmount = (discountedPrice * kdvRate) / 100;

      totalKdv += kdvAmount;
      totalWithKdv += discountedPrice + kdvAmount;
    });

    totalCost = totalCost.toFixed(2);
    totalPrice = totalPrice.toFixed(2);
    totalWithKdv = totalWithKdv.toFixed(2);
    totalKdv = totalKdv.toFixed(2);
    totalDiscount = totalDiscount.toFixed(2);

    return { totalCost, totalPrice, totalWithKdv, totalKdv, totalDiscount };
  };

  handleProcessChange = (index, field, value) => {
    this.setState((prevState) => {
      const updatedProcesses = prevState.processes.map((process, i) =>
        i === index ? { ...process, [field]: value } : process
      );
      return { processes: updatedProcesses };
    });
  };
  handleChange = (e) => {
    const { name, value, files } = e.target;
    const path = name.split('.');
    this.setState(prevState => {
      let updatedData = { ...prevState.formData };
      let currentLevel = updatedData;

      for (let i = 0; i < path.length - 1; i++) {
        if (!currentLevel[path[i]]) {
          currentLevel[path[i]] = {};
        }
        currentLevel = currentLevel[path[i]];
      }

      currentLevel[path[path.length - 1]] = files ? Array.from(files) : value;

      return { formData: updatedData };
    });
  };
  handleImageLoad = (event) => {

  };
  invoiceDetails = async () => {
    const { formData } = this.state;

    // ============================================
    // 1. ÖNCE PREFIX KONTROLÜ YAP
    // ============================================
    try {
      // Servis bilgilerini kontrol et
      const user = JSON.parse(localStorage.getItem('user'));
      const serviceId = user?.service_id;
      const serviceResponse = await apiCall(`business/show/${serviceId}`, 'get', null);

      const invoicePrefix = serviceResponse.invoice_prefix;
      const earchivePrefix = serviceResponse.earchive_invoice_prefix;

      // Prefix'lerden en az biri dolu mu kontrol et
      if (!invoicePrefix && !earchivePrefix) {
        const result = await Swal.fire({
          title: 'Fatura Prefix Eksik!',
          html: `
            <div style="text-align: left;">
              <p><i class="icon-exclamation text-warning" style="font-size: 20px;"></i> 
              <strong>Fatura oluşturabilmek için fatura prefix'lerini tanımlamanız gerekmektedir.</strong></p>
              
              <hr style="margin: 15px 0;" />
              
              <p><strong>Eksik Alanlar:</strong></p>
              <ul style="margin-left: 20px;">
                <li><b>E-Fatura Prefix'i:</b> Tanımlanmamış</li>
                <li><b>E-Arşiv Prefix'i:</b> Tanımlanmamış</li>
              </ul>
              
              <hr style="margin: 15px 0;" />
              
              <p style="color: #666; font-size: 14px;">
                <i class="icon-info"></i> 
                Prefix'ler fatura numaralarının başında kullanılan 3 karakterlik kodlardır. 
                Örnek fatura numarası: <code>SRV2024110000000001</code>
              </p>
              
              <p style="color: #666; font-size: 14px;">
                <i class="icon-settings"></i> 
                <strong>Ayarlar</strong> → <strong>Entegrasyon Hesapları</strong> sayfasından prefix'leri tanımlayabilirsiniz.
              </p>
            </div>
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '<i class="icon-settings"></i> Ayarlara Git',
          cancelButtonText: 'İptal',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          customClass: {
            content: 'text-left',
            popup: 'swal-wide'
          }
        });

        if (result.isConfirmed) {
          // Ayarlar sayfasına yönlendir
          this.props.history.push('/settings-integration-accounts');
        }

        return; // Fatura işlemini durdur
      }

    } catch (error) {
      console.error('Prefix kontrolü sırasında hata:', error);
      Swal.fire({
        title: 'Hata!',
        text: 'Servis bilgileri kontrol edilirken bir hata oluştu.',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
      return;
    }

    // ============================================
    // 2. PREFIX KONTROLÜ BAŞARILI - DEVAM ET
    // ============================================

    try {

      Swal.fire({
        title: 'Bilgiler kontrol ediliyor...',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await apiCall('business/invoice/check-values/' + formData.operationData.id, 'get', null);
      if (response.status === "error") {

        const missingFields = response.missing_fields;

        const formatMissingFields = (fields) => {
          let messages = [];

          if (fields.processes) {
            fields.processes.forEach((process, index) => {
              Object.keys(process).forEach((key) => {
                messages.push(`<b>Process ${index + 1}</b> - ${key}: ${process[key]}`);
              });
            });
          }

          if (fields.customer) {
            Object.keys(fields.customer).forEach((key) => {
              messages.push(`<b>Müşteri</b> - ${fields.customer[key]}`);
            });
          }
          if (fields.settings) {
            Object.keys(fields.settings).forEach((key) => {
              messages.push(`<b>İşletme Ayarları</b> - ${fields.settings[key]}`);
            });
          }
          return messages.join('<br>');
        };
        const errorMessage = formatMissingFields(missingFields);
        Swal.close();
        Swal.fire({
          title: 'Eksik Alanlar!',
          html: `Fatura işlemleri için aşağıdaki alanlar eksik:<br><br>${errorMessage}`,
          icon: 'warning',
          confirmButtonText: 'Tamam',
          customClass: {
            content: 'text-left',
          }
        });

      } else {
        Swal.close();
        const url = `${process.env.PUBLIC_URL}/invoice/${formData.operationData.id}`;
        window.open(url, '_blank');
      }

    } catch (error) {
      Swal.close();
      Swal.fire({
        title: 'Hata!',
        text: 'Veriler alınırken bir hata oluştu.',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
    }

  };
  showExperForm = () => {
    const { formData } = this.state;
    const experData = new FormData();
    experData.append('operation_id', formData.operationData.id);
    const url = `${process.env.REACT_APP_MAIN_URL}/exper-report?operation_id=${formData.operationData.id}`;
    window.open(url, '_blank');
  };
  handleImageDelete = async (name) => {
    const { formData, images } = this.state;
    const prevImgData = images;
    const updatedImages = images.filter(image => image.name !== name);
    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et'
    });

    if (result.isConfirmed) {
      try {

        await apiCall('business/vehicle/delete-image', 'post', { vehicleID: formData.operationData.vehicle_id, name: name })
        if (updatedImages.length === 0) {
          this.setState({ images: [{ original: logo, thumbnail: logo, name: "logo-icon.png" }] });
        } else {
          this.setState({ images: updatedImages });
        }
        Swal.fire(
          'Silindi!',
          'Resim başarıyla silindi.',
          'success'
        );
      } catch (error) {
        mainHelper.toastMessage('error', 'Resim silinirken bir hata oluştu.')
        this.setState({ images: prevImgData });
        Swal.fire(
          'Hata!',
          'Silme işlemi başarısız oldu.',
          'error'
        );
      }
    }
  };

  renderCustomItem = (item, index) => {
    const isFullscreen = this.state.isFullscreen;
    const { userPermissions } = this.props;
    const userHasDeleteVehicleImagePermission = userPermissions.includes('delete service vehicle image');
    return (
      <div style={{ maxWidth: '750px', margin: '0 auto', position: 'relative', overflow: 'hidden' }}>
        {item && item.original ? (
          <>
            <img src={item.original} alt="car_image" style={{ width: '100%' }} />
            {item.name !== "logo-icon.png" && !isFullscreen ? (
              <button disabled={!userHasDeleteVehicleImagePermission} className="btn btn-danger btn-sm" onClick={(e) => {
                e.stopPropagation();
                this.handleImageDelete(item.name);
              }} style={{ position: "absolute", bottom: 20, left: 10 }}>
                <i className="icon-trash"></i>
              </button>
            ) : null}

            <p style={{ textAlign: 'center' }}>{item.description}</p>
          </>
        ) : (
          <img src={require("../../assets/images/logo-icon.svg")} alt="default" className="fixed-size-image" />
        )}
      </div>
    );
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    const loadingStates = {
      'operationStatus': 'statusLoading',
      'processData': 'processLoading',
      'operationData': 'operationLoading',
      'customerData': 'customerLoading',
      'vehicleData': 'vehicleLoading',
    };
    const targetId = e.target.id;

    this.setState((prevState) => ({
      ...prevState,
      [loadingStates[targetId]]: true
    }));

    const { formData } = this.state;
    const data = new FormData();
    const form = formData[e.target.id];
    const formUrls = {
      'customerData': "business/customer/update/" + formData.customerData.id,
      'vehicleData': "business/vehicle/update/" + formData.vehicleData.id,
      'operationData': "business/operation/update-operation-info-update/" + formData.operationData.id,
      'operationStatus': "business/operation/update-status/" + formData.operationData.id,
      'processData': "business/operation/process-data/" + formData.operationData.id,
    };

    if (e.target.id === 'operationData') data.append('_version',formData.operationData.version || '');
    if (e.target.id === "processData") {
      data.append('process', JSON.stringify(this.state.processes));
      data.append('_version', formData.operationData.version || '');
    } else {
      Object.keys(form).forEach(key => {
        if (Array.isArray(form[key])) {
          form[key].forEach(file => {
            data.append(`${key}[]`, file);
          });
        } else {
          data.append(key, form[key]);
        }
      });
    }

    try {
      const response = await apiCall(formUrls[e.target.id], 'post', data);
      if (response.version) this.setState(prev=>({formData:{...prev.formData,operationData:{...prev.formData.operationData,version:response.version}}}));



      this.setState((prevState) => ({
        ...prevState,
        [loadingStates[targetId]]: false
      }));
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState((prevState) => ({
        ...prevState,
        [loadingStates[targetId]]: false
      }));

    }
  };
  customerDetail = async () => {
    try {
      Swal.fire({
        title: 'Yükleniyor...',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });
      const { formData } = this.state;

      const response = await apiCall(`business/customer/info/${formData.operationStatus.customer_id}`, 'get', null);
      if (response.city && response.city.id) {
        var dist = await apiCall(`get-dist/${response.city.id}`, 'get', null);
      } else {
        dist = '';
      }
      const updatedCustomerData = {
        ...formData,
        customerData: {
          ...formData.customerData,
          id: response.id,
          version: response.version,
          name: response.name,
          surname: response.surname,
          phone: response.phone || '',
          address: response.address || '',
          email: response.email || '',
          tax_district: response.tax_district || '',
          tax_no: response.tax_no || '',
          title: response.title || '',
          city_id: response.city?.id || '',
          district_id: response.district?.id || '',
        }
      };

      this.setState({
        formData: updatedCustomerData,
        customerLoading: false,
        districts: dist,
      });
      Swal.close();
      this.props.openCustomerDetailModel();
    } catch (error) {
      Swal.close();
      Swal.fire({
        title: 'Müşteri Bilgileri',
        text: 'Bir sorun oluştu lütfen daha sonra tekrar deneyiniz!',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
      console.error(error);

    }
  }
  vehicleDetail = async () => {
    try {
      Swal.fire({
        title: 'Yükleniyor...',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });
      const { formData } = this.state;
      const response = await apiCall(`business/vehicle/moto-info/${formData.operationData.vehicle_id}`, 'get', null);
      await this.getModels(response.brand.id);
      const updatedVehicleData = {
        ...formData,
        vehicleData: {
          ...formData.vehicleData,
          id: response.id,
          version: response.version,
          brand: response.moto_brand.id,
          branch_id: response.branch.id,
          model: response.moto_model.id,
          plate: response.plate,
          year: response.year,
          km: response.km,
          chassis_no: response.chassis_no,
          engine_no: response.engine_no || '',
          package_name: response.package_name || '',
          engine_size: response.engine_size || '',
          key_no: response.key_no || '',
          details: response.details || '',
          vehicleImages: response.images ? JSON.parse(response.images) : [],
          maintenance_date: response.maintenance[0]?.maintenance_date || '',
          next_maintenance_date: response.maintenance[0]?.next_maintenance_date || '',
          inspection_date: response.inspection[0]?.inspection_date || '',
          next_inspection_date: response.inspection[0]?.next_inspection_date || '',
          gear_type: response.gear_type || '',
          cooling: response.moto_model.cooling || "Belirtilmemiş",
          body_type: response.moto_model.body_type || "Belirtilmemiş",
          fuel_type: response.moto_model.fuel_type || "Belirtilmemiş",
          fuel_tank: response.moto_model.fuel_tank || "Belirtilmemiş",
          number_of_gears: response.moto_model.number_of_gears || "Belirtilmemiş",
          stroke: response.moto_model.stroke || "Belirtilmemiş",
          cylinder: response.moto_model.cylinder || "Belirtilmemiş",
          hp: response.moto_model.hp || "Belirtilmemiş",
        }
      };
      const selectedBrandOption = {
        value: response.moto_brand.id,
        label: response.moto_brand.name,
      }
      const selectedModelOption = {
        value: response.moto_model.id,
        label: response.moto_model.name,
      }
      this.setState({
        formData: updatedVehicleData,
        vehicleLoading: false,
        selectedBrand: selectedBrandOption,
        selectedModel: selectedModelOption,
      });
      Swal.close();
      this.props.openVehicleDetailModel();
    } catch (error) {
      Swal.close();
      Swal.fire({
        title: 'Araç Bilgileri',
        text: 'Bir sorun oluştu lütfen daha sonra tekrar deneyiniz!',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
      console.error(error);

    }
  }
  render() {

    const {
      formData,
      branches,
      types,
      employes,
      images,
      created_at,
      status,
      statusLoading,
      processLoading,
      operationLoading,
      customerLoading,
      vehicleLoading,
      brands, models,
      selectedBrand, selectedModel,
      cities, districts
    } = this.state;
    const { totalCost, totalPrice, totalKdv, totalWithKdv, totalDiscount } = this.calculateTotals();
    const { userPermissions, isVehicleDetailModalOpen, isCustomerDetailModalOpen } = this.props;
    const inspection = formData.vehicleData.inspection_date.split(' ')[0];
    const next_inspection = formData.vehicleData.next_inspection_date.split(' ')[0];
    const maintenance = formData.vehicleData.maintenance_date.split(' ')[0];
    const next_maintenance = formData.vehicleData.next_maintenance_date.split(' ')[0];
    const userHasUpdateServiceCustomerInfo = userPermissions.includes('update service customer');
    const userHasUpdateServiceStatus = userPermissions.includes('update service status');
    const userHasUpdateServiceInfo = userPermissions.includes('update service');
    const userHasUpdateServiceVehicleInfo = userPermissions.includes('update service vehicle');
    const userHasUpdateServiceProcess = userPermissions.includes('update service process');
    const userHasViewServiceForm = userPermissions.includes('view form');
    const userHasViewInvoice = userPermissions.includes('invoice process');
    const statusComplete = Object.keys(status).some(key => {
      if (status[key].id === formData.operationStatus.statu_id && status[key].name === 'Tamamlandı') {
        return true;
      }
      return false;
    });

    return (
      <div style={{ flex: 1 }} onClick={() => { document.body.classList.remove("offcanvas-active"); }}>
        <div>
          <div className="container-fluid">
            <PageHeader HeaderText="Servis Detayı" Breadcrumb={[
              { name: "Motosiklet Servisleri", navigate: "services-moto" },
              { name: "Detay", navigate: "" },
            ]} />
            <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
              <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div className="m-t-30">
                  <img src={require('../../assets/images/logo-white.png')} width="150" alt="Servicezone" />
                </div>
                <p>Yükleniyor</p>
                <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
              </div>
            </div>
            <div className={isCustomerDetailModalOpen ? "modal fade show" : "modal fade"} role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="title" id="defaultModalLabel">
                      Müşteri Detayları
                    </h4>
                  </div>
                  <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <form id="customerData" onSubmit={this.handleSubmit}>
                      <h6>Müşteri Bilgileri</h6>
                      <div className="form-group">
                        <label htmlFor="name" className="font-weight-bold text-cyan">
                          Adı
                        </label>
                        <input name="customerData.name"
                          id="name"
                          className="form-control"
                          placeholder="Ad"
                          type="text"
                          value={formData.customerData.name}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="surname" className="font-weight-bold text-cyan">
                          Soyadı
                        </label>
                        <input name="customerData.surname"
                          id="surname"
                          className="form-control"
                          placeholder="Soyad"
                          type="text"
                          value={formData.customerData.surname}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="phone" className="font-weight-bold text-cyan">
                          Telefon
                        </label>
                        <input name="customerData.phone"
                          id="phone"
                          className="form-control"
                          placeholder="Telefon"
                          type="text"
                          value={formData.customerData.phone}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="email" className="font-weight-bold text-cyan">
                          Email
                        </label>
                        <input name="customerData.email"
                          id="email"
                          className="form-control"
                          placeholder="Email adresi"
                          type="email"
                          value={formData.customerData.email}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <select
                          name="customerData.city_id"
                          className="form-control"
                          id="city_id"
                          value={formData.customerData.city_id}
                          onChange={this.handleCityChange}>
                          <option value="">İl Seçiniz</option>
                          {cities && (cities.map(city => (
                            <option key={city.id}
                              value={city.id}>{city.name}</option>
                          )))}

                        </select>
                      </div>
                      <div className="form-group">
                        <select
                          name="customerData.district_id"
                          className="form-control"
                          id="district_id"
                          value={formData.customerData.district_id}
                          onChange={this.handleChange}>
                          <option value="">İlçe Seçiniz</option>
                          {districts && (districts.map(district => (
                            <option key={district.id}
                              value={district.id}>{district.name}</option>
                          )))}
                        </select>
                      </div>
                      <div className="form-group">
                        <input
                          name="customerData.title"
                          id="title"
                          className="form-control"
                          placeholder="Ünvan"
                          value={formData.customerData.title}
                          type="text"
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <input
                          name="customerData.tax_no"
                          id="tax_no"
                          className="form-control"
                          placeholder="Vergi veya TC no"
                          value={formData.customerData.tax_no}
                          type="number"
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <input
                          name="customerData.tax_district"
                          id="tax_district"
                          className="form-control"
                          placeholder="Vergi Dairesi"
                          value={formData.customerData.tax_district}
                          type="text"
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="address" className="font-weight-bold text-cyan">
                          Adres
                        </label>
                        <textarea name="customerData.address"
                          id='address'
                          className="form-control"
                          placeholder="Adres"
                          value={formData.customerData.address}
                          onChange={this.handleChange}>
                        </textarea>
                      </div>
                      <div className="form-group text-center">
                        {customerLoading ? (
                          <button className="btn btn-outline-primary btn-block" disabled={true}
                            style={{ textAlign: "-webkit-center" }}>
                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                              color="#268bd2"></ReactLoading>
                          </button>
                        ) :
                          <button disabled={!userHasUpdateServiceCustomerInfo}
                            className="btn btn-outline-primary btn-block" type="submit">
                            Güncelle
                          </button>}
                      </div>
                    </form>

                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      onClick={this.props.closeCustomerDetailModel}
                      className="btn btn-simple"
                      data-dismiss="modal"
                    >
                      Kapat
                    </button>
                  </div>
                </div>
              </div>

            </div>
            <div className={isVehicleDetailModalOpen ? "modal fade show" : "modal fade"} role="dialog">
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="title" id="defaultModalLabel">
                      Motor Detayları
                    </h4>
                  </div>
                  <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <form className="form" id="vehicleData" onSubmit={this.handleSubmit} encType='multipart/form-data'
                      style={{ display: "contents" }}>

                      <div className="d-flex">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="plate" className="font-weight-bold text-cyan">
                              Plaka
                            </label>
                            <input name="vehicleData.plate"
                              id="plate"
                              className="form-control"
                              placeholder="Plaka"
                              type="text"
                              value={formData.vehicleData.plate}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="brand" className="font-weight-bold text-cyan">
                              Marka
                            </label>
                            <Select
                              value={selectedBrand}
                              onChange={this.handleBrandChange}
                              options={brands}
                              placeholder="Marka Seçin"
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: state.isFocused ? 'red' : 'red',
                                  boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                  '&:hover': { borderColor: 'red' }
                                })
                              }}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="model" className="font-weight-bold text-cyan">
                              Model
                            </label>
                            <Select
                              value={selectedModel}
                              onChange={this.handleModelChange}
                              options={models}
                              placeholder="Model Seçin"
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: state.isFocused ? 'red' : 'red',
                                  boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                  '&:hover': { borderColor: 'red' }
                                })
                              }}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="year" className="font-weight-bold text-cyan">
                              Model yılı
                            </label>
                            <input name="vehicleData.year"
                              id="year"
                              className="form-control"
                              placeholder="Model Yılı"
                              type="number"
                              value={formData.vehicleData.year}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="vehicleData.gear_type" className="font-weight-bold text-cyan">
                              Vites Tipi
                            </label>
                            <select name="vehicleData.gear_type" id='gear_type'
                              className="form-control"
                              value={formData.vehicleData.gear_type}
                              onChange={this.handleChange}>
                              <option value="">Vites Tipi Seçiniz</option>
                              <option value="otomatik">Otomatik</option>
                              <option value="manuel">Manuel</option>

                            </select>
                          </div>

                          <div className="form-group">
                            <label htmlFor="maintenance" className="font-weight-bold text-cyan">
                              Bakım tarihi
                            </label>
                            <input name="vehicleData.maintenance_date"
                              id="maintenance_date"
                              className="form-control"
                              type="date"
                              value={maintenance}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="inspection" className="font-weight-bold text-cyan">
                              Muayene tarihi
                            </label>
                            <input name="vehicleData.inspection_date"
                              id="inspection_date"
                              className="form-control"
                              type="date"
                              value={inspection}
                              onChange={this.handleChange}
                            />
                          </div>

                        </div>
                        <div className="col-lg-6 col-md-12">
                          <h6>&nbsp;</h6>
                          <div className="form-group">
                            <label htmlFor="engine_size" className="font-weight-bold text-cyan">
                              Motor hacmi
                            </label>
                            <input name="vehicleData.engine_size"
                              id="engine_size"
                              className="form-control"
                              placeholder="Motor Hacmi"
                              type="text"
                              value={formData.vehicleData.engine_size}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="km" className="font-weight-bold text-cyan">
                              Km
                            </label>
                            <input name="vehicleData.km"
                              id="km"
                              className="form-control"
                              placeholder="Km"
                              type="number"
                              value={formData.vehicleData.km}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="chassis_no" className="font-weight-bold text-cyan">
                              Şase No
                            </label>
                            <input name="vehicleData.chassis_no"
                              id="chassis_no"
                              className="form-control"
                              placeholder="Şase No"
                              type="text"
                              value={formData.vehicleData.chassis_no}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="details" className="font-weight-bold text-cyan">
                              Araç detayları
                            </label>
                            <textarea name="vehicleData.details"
                              id="details"
                              className="form-control"
                              placeholder="Araç detayları"
                              value={formData.vehicleData.details}
                              onChange={this.handleChange}
                            />

                          </div>
                          <div className="form-group">
                            <label htmlFor="key_no" className="font-weight-bold text-cyan">
                              Anahtar No
                            </label>
                            <input name="vehicleData.key_no"
                              id="key_no"
                              className="form-control"
                              placeholder="Anahtar No"
                              type="text"
                              value={formData.vehicleData.key_no}
                              onChange={this.handleChange}
                            />
                          </div>

                          <div className="form-group">
                            <label htmlFor="next_maintenance" className="font-weight-bold text-cyan">
                              Sonraki bakım tarihi
                            </label>
                            <input name="vehicleData.next_maintenance_date"
                              id="next_maintenance_date"
                              className="form-control"
                              type="date"
                              value={next_maintenance}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="next_inspection" className="font-weight-bold text-cyan">
                              Sonraki muayene tarihi
                            </label>
                            <input name="vehicleData.next_inspection_date"
                              id="next_inspection_date"
                              className="form-control"
                              type="date"
                              value={next_inspection}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="vehicleImages" className="font-weight-bold text-cyan">
                              Araç resimleri ekle
                            </label>
                            <input name="vehicleData.vehicleImages"
                              id="vehicleImages"
                              className="form-control"
                              type="file"
                              multiple={true}
                              onChange={this.handleChange}
                            />
                          </div>

                        </div>
                      </div>
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">
                          {vehicleLoading ? (
                            <button className="btn btn-outline-primary btn-block" disabled={true}
                              style={{ textAlign: "-webkit-center" }}>
                              Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                color="#268bd2"></ReactLoading>
                            </button>
                          ) :
                            <button disabled={!userHasUpdateServiceVehicleInfo}
                              className="btn btn-outline-primary btn-block" type="submit">
                              Güncelle
                            </button>}
                        </div>
                      </div>
                    </form>
                    <div className="col-lg-12 text-center mt-3"><h6>Diğer Özellikler</h6></div>
                    <hr />
                    <div className="body text-center" style={{ display: "grid", gridTemplateColumns: " 1fr 1fr", gap: 10 }}>
                      <div className="grid-item">
                        <small className="text-muted">Motor Hacmi </small>
                        <p>{formData.vehicleData.engine_size}</p>
                      </div>
                      <div className="grid-item" style={{ display: "flex", flexDirection: "column" }}>
                        <small className="text-muted">Motor Tipi:</small>
                        <p>{formData.vehicleData.body_type}
                        </p>
                      </div>
                      <div className="grid-item">
                        <small className="text-muted">Silindir </small>
                        <p>{formData.vehicleData.cylinder}</p>
                      </div>
                      <div className="grid-item">
                        <small className="text-muted">Hp </small>
                        <p>{formData.vehicleData.hp}</p>
                      </div>
                      <div className="grid-item" style={{ display: "flex", flexDirection: "column" }}>
                        <small className="text-muted">Soğutma:</small>
                        <p>{formData.vehicleData.cooling}
                        </p>
                      </div>
                      <div className="grid-item">
                        <small className="text-muted">Zaman </small>
                        <p>{formData.vehicleData.number_of_gears}</p>
                      </div>
                      <div className="grid-item" style={{ display: "flex", flexDirection: "column" }}>
                        <small className="text-muted">Yakıt tank kapasitesi: </small>
                        <p>{formData.vehicleData.fuel_tank}</p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      onClick={this.props.closeVehicleDetailModel}
                      className="btn btn-simple"
                      data-dismiss="modal"
                    >
                      Kapat
                    </button>
                  </div>
                </div>
              </div>

            </div>
            <div className="card">
              <div className="body">
                <h4 className="text-center" style={{ color: "rgb(51 51 51 / 65%)", fontSize: "45px", fontWeight: "bold" }}>
                  {formData.operationData.plate.toUpperCase()}
                </h4>
                {userHasViewServiceForm ? (
                  <button title="Araç Formu Görüntüle" className="btn btn-outline-info float-right"
                    onClick={this.showExperForm}>
                    <i className="fa fa-file-pdf-o"></i>
                  </button>
                ) : ""}
                {userHasViewInvoice && this.state.processes.some(process =>
                  process.process && process.price && process.kdv) ? (
                  <button title="Fatura İşlemleri" className="btn btn-outline-success float-right mr-1"
                    onClick={this.invoiceDetails}>
                    <i className="fa fa-file-text-o"></i>
                  </button>
                ) : ""}
              </div>
              <div className="body">
                <div className="row clearfix">
                  <div className="col-lg-6 col-md-12">
                    <label htmlFor="statu_id" className="font-weight-bold text-cyan text-center"
                      style={{ width: "100%" }}>
                      Araç Resimleri
                    </label>
                    <div className="preview">
                      <div className="gallery b4gallery">
                        <ImageGallery
                          items={images}
                          renderItem={(item, index) => (
                            <div key={index} style={{ width: '100%' }}>
                              {this.renderCustomItem(item, index)}
                            </div>
                          )}
                          onImageLoad={this.handleImageLoad}
                          lazyLoad={true}
                          loading={lazy}
                          onScreenChange={isFullscreen => this.setState({ isFullscreen })}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="details col-lg-6 col-md-12">
                    <div className="col-lg-12 d-flex">
                      <div className="details col-lg-12 col-md-12">
                        <form id="operationStatus" onSubmit={this.handleSubmit}>
                          <div className="form-group">
                            <label htmlFor="statu_id" className="font-weight-bold text-cyan">
                              Durum
                            </label>
                            <select name="operationStatus.statu_id" id='statu_id' className="form-control"
                              value={formData.operationStatus.statu_id}
                              onChange={this.handleChange}>
                              <option value="">Durum Seçiniz</option>
                              {status && (status.map(statu => (
                                <option key={statu.id} value={statu.id}>{statu.name}</option>
                              )))}
                            </select>
                          </div>
                          <div className="form-group">
                            <label htmlFor="operationStatus.status_details" className="font-weight-bold text-cyan">
                              Durum Detayları <small>(Durum sorgu ekranında bu detaylar müşteri tarafından
                                görüntülenecektir.)</small>
                            </label>
                            <textarea name="operationStatus.status_details" id="operationStatus.status_details"
                              value={formData.operationStatus.status_details} className="form-control"
                              onChange={this.handleChange}></textarea>
                          </div>
                          <input type="hidden" name="operationStatus.customer_id" id="customer_id"
                            value={formData.customerData.id} onChange={this.handleChange} />
                          <div className="form-group text-center btn-block">
                            {statusLoading ? (

                              <button className="btn btn-outline-primary btn-sm" disabled={true}
                                style={{ textAlign: "-webkit-center" }}>
                                Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                  color="#268bd2"></ReactLoading>
                              </button>
                            ) :
                              <button disabled={!userHasUpdateServiceStatus}
                                className="btn btn-outline-primary btn-lg" type="submit">
                                Güncelle
                              </button>
                            }
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="col-lg-12 text-center"><h6>Özet</h6></div>
                    <hr />
                    <div className="body" style={{ display: "grid", gridTemplateColumns: " 1fr 1fr", gap: 10 }}>
                      <div className="grid-item" style={{ display: "flex", flexDirection: "column" }}>
                        <small className="text-muted">Müşteri:</small>
                        <p>{formData.operationData.customer_name + ' ' + formData.operationData.customer_surname}
                          <button onClick={this.customerDetail} type="button"
                            className="btn btn-outline-dark btn-sm ml-2"><i className="icon-eye"></i></button>
                        </p>
                      </div>
                      <div className="grid-item" style={{ display: "flex", flexDirection: "column" }}>
                        <small className="text-muted">Araç:</small>
                        <p>{formData.operationData.brand + ' ' + formData.operationData.model}
                          <button onClick={this.vehicleDetail} type="button"
                            className="btn btn-outline-dark btn-sm ml-2"><i className="icon-eye"></i></button>
                        </p>
                      </div>
                      <div className="grid-item" style={{ display: "flex", flexDirection: "column" }}>
                        <small className="text-muted">Şube: </small>
                        {branches && branches.map(branch => {
                          if (branch.id === formData.operationData.branch_id) {
                            return <p key={branch.id}>{branch.name}</p>
                          }
                          return null;

                        })}
                      </div>
                      <div className="grid-item">
                        <small className="text-muted">Servis Tipi: </small>
                        {types && types.map(type => {
                          if (type.id === formData.operationData.operation_type_id) {
                            return <p key={type.id}>{type.name}</p>
                          }
                          return null;
                        })}
                      </div>
                      <div className="grid-item">
                        <small className="text-muted">Tutar: </small>
                        <p>{formattedPrice(totalWithKdv)}</p>
                      </div>
                      <div className="grid-item">
                        <small className="text-muted">Oluşturulma tarihi: </small>
                        <p className="m-b-0">{created_at}</p>
                      </div>
                      {statusComplete ? (
                        <div className="grid-item">
                          <small className="text-muted">Müşteri değerlendirmesi: </small>
                          <div className="rating">
                            <div className="stars">
                              {Array(Number(formData.operationData.review_count)).fill(0).map((_, index) => (
                                <span key={index} className="icon-star text-warning"></span>
                              ))}
                            </div>
                          </div>
                        </div>
                      ) : ""}

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h6>İşlemler</h6>
                    <form id="processData" onSubmit={this.handleSubmit}>
                      {this.state.processes.map((process, index) => (
                        <div key={index} className="form-row align-items-end mb-3">

                          <div className="col-lg">
                            <label htmlFor={`process`}>Ürün/Hizmet</label>
                            <input
                              type="text"
                              className="form-control"
                              id={`process`}
                              placeholder="Ürün/Hizmet"
                              value={process.process}
                              onChange={(e) => this.handleProcessChange(index, "process", e.target.value)}
                            />
                          </div>

                          <div className="col-lg">
                            <label htmlFor={`unit`}>Birim</label>
                            <select
                              id={`unit`}
                              className="form-control"
                              value={process.unit}
                              onChange={(e) => this.handleProcessChange(index, "unit", e.target.value)}
                            >
                              <option value="">Seçiniz</option>
                              <option value="C62">Adet</option>
                              <option value="KGM">Kg</option>
                              <option value="LTR">Litre</option>
                              <option value="MTK">Metre Kare</option>
                              <option value="MTQ">Metre Küp</option>
                              <option value="PR">Çift</option>
                            </select>
                          </div>

                          <div className="col-lg">
                            <label htmlFor={`quantity`}>Miktar
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id={`quantity`}
                              placeholder="Miktar"
                              value={process.quantity}
                              onChange={(e) => this.handleProcessChange(index, "quantity", e.target.value)}
                            />
                          </div>
                          <div className="col-lg">
                            <label htmlFor={`kdv`}>Kdv Oranı (%)</label>
                            <input
                              type="number"
                              className="form-control"
                              id={`kdv`}
                              placeholder="Kdv Oranı"
                              value={process.kdv}
                              onChange={(e) => this.handleProcessChange(index, "kdv", e.target.value)}
                            />
                          </div>
                          <div className="col-lg">
                            <label htmlFor={`discount`}>İndririm Oranı (%)</label>
                            <input
                              type="number"
                              className="form-control"
                              id={`discount`}
                              placeholder="İndirim Oranı"
                              value={process.discount}
                              onChange={(e) => this.handleProcessChange(index, "discount", e.target.value)}
                            />
                          </div>

                          <div className="col-lg">
                            <label htmlFor={`cost`}>Maliyet</label>
                            <input
                              type="number"
                              className="form-control"
                              id={`cost`}
                              placeholder="Maliyet"
                              value={process.cost}
                              onChange={(e) => this.handleProcessChange(index, "cost", e.target.value)}
                            />
                          </div>

                          <div className="col-lg">
                            <label htmlFor={`price`}>Tutar</label>
                            <input
                              type="number"
                              className="form-control"
                              id={`price`}
                              placeholder="Tutar"
                              value={process.price}
                              onChange={(e) => this.handleProcessChange(index, "price", e.target.value)}
                            />
                          </div>

                          <div className="col-auto">
                            {index > 0 ? (
                              <button
                                type="button"
                                className="btn btn-outline-danger"
                                onClick={() => this.handleRemoveProcess(index)}
                              >
                                -
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-outline-success"
                                onClick={this.handleAddProcess}
                              >
                                +
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                      <div className="row justify-content-center">
                        <div className="col-lg-12 text-center">
                          <h6>Özet</h6>
                        </div>
                        <hr />
                        <div className="body" style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                          justifyContent: "space-between"
                        }}>
                          <div className="grid-item" style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                          }}>
                            <small className="text-muted mb-1">Toplam Maliyet:</small>
                            <p><strong>{formattedPrice(totalCost)}</strong></p>
                          </div>
                          <div className="grid-item" style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                          }}>
                            <small className="text-muted mb-1">Toplam Tutar: </small>
                            <p><strong>{totalPrice}₺</strong></p>
                          </div>
                          <div className="grid-item" style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                          }}>
                            <small className="text-muted mb-1">Kdv Tutarı:</small>
                            <p><strong>{totalKdv}₺</strong></p>
                          </div>
                          <div className="grid-item" style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                          }}>
                            <small className="text-muted mb-1">Toplam İndirim Tutarı:</small>
                            <p><strong>{totalDiscount}₺</strong></p>
                          </div>
                          <div className="grid-item" style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                          }}>
                            <small className="text-muted mb-1">Kdv Dahil Tutar: </small>
                            <p><strong>{totalWithKdv}₺</strong></p>
                          </div>
                        </div>
                      </div>
                      <div className="body">
                        <div className="row clearfix justify-content-center">
                          <div className="col-lg-6 col-md-12">

                            {processLoading ? (
                              <button className="btn btn-outline-primary btn-block" disabled={true}
                                style={{ textAlign: "-webkit-center" }}>
                                Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                  color="#268bd2"></ReactLoading>
                              </button>
                            ) :
                              <button disabled={!userHasUpdateServiceProcess}
                                className="btn btn-outline-primary btn-block" type="submit">
                                Kaydet
                              </button>}

                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h6>Servis Bilgileri</h6>
                    <form id="operationData" onSubmit={this.handleSubmit}>
                      <div className="row">
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <label htmlFor="branch_id" className="font-weight-bold text-cyan">
                              Şube
                            </label>
                            <select name="operationData.branch_id" id='branch_id' className="form-control"
                              value={formData.operationData.branch_id}
                              onChange={this.handleChange}>
                              <option value="">Şube Seçiniz</option>
                              {branches && (branches.map(branch => (
                                <option key={branch.id} value={branch.id}>{branch.name}</option>
                              )))}
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <label htmlFor="assigned_employee_id" className="font-weight-bold text-cyan">
                              Atanan personel
                            </label>
                            <select name="operationData.assigned_employee_id" id='assigned_employee_id'
                              className="form-control"
                              value={formData.operationData.assigned_employee_id}
                              onChange={this.handleChange}>
                              <option value="">Personel Seçiniz</option>
                              {employes && (employes.map(employe => (
                                <option key={employe.id} value={employe.id}>{employe.name} {employe.surname}</option>
                              )))}
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <label htmlFor="operation_type_id" className="font-weight-bold text-cyan">
                              Servis tipi
                            </label>
                            <select name="operationData.operation_type_id" id='operation_type_id'
                              className="form-control"
                              value={formData.operationData.operation_type_id}
                              onChange={this.handleChange}>
                              <option value="">Servis Tipi Seçiniz</option>
                              {types && (types.map(type => (
                                <option key={type.id} value={type.id}>{type.name}</option>
                              )))}
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label htmlFor="description" className="font-weight-bold text-cyan">
                              Servis Açıklaması
                            </label>
                            <textarea name="operationData.description" value={formData.operationData.description}
                              id='description' className="form-control textarea-height-detail"
                              placeholder="Servis Açıklaması"
                              onChange={this.handleChange}>
                            </textarea>
                          </div>
                        </div>

                      </div>
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            {operationLoading ? (
                              <button className="btn btn-outline-primary btn-block" disabled={true}
                                style={{ textAlign: "-webkit-center" }}>
                                Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                  color="#268bd2"></ReactLoading>
                              </button>
                            ) : (
                              <button disabled={!userHasUpdateServiceInfo}
                                className="btn btn-outline-primary btn-block"
                                type="submit">
                                Güncelle
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
      ;
  }
}

const mapStateToProps = (state) => {
  //const {isSecuritySystem} = state.ioTReducer;
  const {
    isCustomerDetailModalOpen,
    isVehicleDetailModalOpen,
  } = state.mailInboxReducer;
  return { isCustomerDetailModalOpen, isVehicleDetailModalOpen }
};

export default withPermissions(withRouter(connect(mapStateToProps, {
  openCustomerDetailModel,
  openVehicleDetailModel,
  closeCustomerDetailModel,
  closeVehicleDetailModel
})(ServiceMotoDetail)));
